import React from 'react';
import style from './index.module.scss';
import { useKVConfig } from '@/hooks';

const AboutUsPage: React.FC = () => {
  const { value } = useKVConfig(`CUSTOM_PAGE_about-us`, true);

  return (
    <div
      className={style.container}
      dangerouslySetInnerHTML={{ __html: value! }}
    ></div>
  );
};

export default AboutUsPage;
